import { render, staticRenderFns } from "./IframeCheckout.vue?vue&type=template&id=c8c0533e&scoped=true&"
import script from "./IframeCheckout.vue?vue&type=script&lang=js&"
export * from "./IframeCheckout.vue?vue&type=script&lang=js&"
import style0 from "./IframeCheckout.vue?vue&type=style&index=0&id=c8c0533e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c0533e",
  null
  
)

export default component.exports